import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Plus, ShoppingBag } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useCart } from "@/contexts/CartContext";
export const CartHeader: React.FC = () => {
  const navigate = useNavigate();
  const {
    items
  } = useCart();

  // Determine the best return path based on cart contents
  const getReturnPath = () => {
    if (items.length === 0) {
      return "/"; // If cart is empty, go to home page
    }

    // Check for fishing permits
    const hasFishingPermits = items.some(item => item.type === "fishing");

    // Check for camping permits
    const hasCampingPermits = items.some(item => item.type === "camping" || item.type === "general-camping");

    // Check for hunting permits
    const hasHuntingPermits = items.some(item => item.type === "hunting");

    // Determine the most appropriate return path
    if (hasFishingPermits && !hasCampingPermits && !hasHuntingPermits) {
      return "/permits/fishing";
    } else if (hasCampingPermits && !hasFishingPermits && !hasHuntingPermits) {
      return "/permits/camping";
    } else if (hasHuntingPermits && !hasFishingPermits && !hasCampingPermits) {
      return "/permits/hunting";
    } else {
      // Mixed cart or other scenarios
      return "/"; // Default to home page
    }
  };

  // Get button label based on return path
  const getButtonLabel = () => {
    const path = getReturnPath();
    switch (path) {
      case "/permits/fishing":
        return "Back to Fishing Permits";
      case "/permits/camping":
        return "Back to Camping Permits";
      case "/permits/hunting":
        return "Back to Hunting Permits";
      default:
        return "Continue Shopping";
    }
  };
  const handleNavigation = () => {
    // Always use direct navigation to a specific path
    const targetPath = getReturnPath();
    console.log("Navigating to:", targetPath);

    // Simply navigate to the determined path
    navigate(targetPath);
  };
  const handleAddPermit = () => {
    navigate('/');
  };
  return <div className="flex items-center justify-between mb-6">
      <div className="flex items-center">
        <Button variant="outline" size="sm" onClick={handleNavigation} className="mr-4 bg-white">
          <ArrowLeft className="mr-1 h-4 w-4" />
          {getButtonLabel()}
        </Button>
        <h1 className="text-2xl md:text-3xl font-bold text-tribal-secondary">Your Cart</h1>
      </div>
      
      
    </div>;
};